import { Typography } from '@mui/material'
import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from '../../styles/theme'

export const Header = ({ textHeader }: { textHeader: string }) => {
  return (
    <ThemeProvider theme={theme}>
      <Typography variant="h1" component="h1">
        {textHeader}
      </Typography>
    </ThemeProvider>
  )
}
